import { diagnosticEngine } from './DiagnosticEngine';
import { Incident } from '../types/autofix';

export interface LLMConfig {
  apiKey: string;
  provider: 'gemini' | 'openai' | 'local';
}

export class LLMAgent {
  private config: LLMConfig = {
    apiKey: '',
    provider: 'gemini',
  };

  public setConfig(config: Partial<LLMConfig>) {
    this.config = { ...this.config, ...config };
  }

  public getConfig(): LLMConfig {
    return { ...this.config };
  }

  public async diagnoseWithServer(
    bugId: string,
    crashDump?: any,
    flightRecorderLogs?: any[]
  ): Promise<any> {
    try {
      console.log('[AutoFix Agent] Calling server-side Gemini 3.8 Flash diagnosis route (/api/diagnose)...');
      const res = await fetch('/api/diagnose', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          bugId,
          crashDump,
          flightRecorderLogs,
        }),
      });
      if (res.ok) {
        const data = await res.json();
        console.log('[AutoFix Agent] Server diagnosis result:', data);
        return data;
      }
    } catch (err) {
      console.warn('[AutoFix Agent] Server call failed, using local neuro-symbolic engine:', err);
    }
    return null;
  }

  public async diagnoseWithLLM(bugId: string, customPrompt?: string): Promise<Incident> {
    return await diagnosticEngine.healIncident(bugId, {
      userAction: customPrompt || 'Triggered via Agent Control HUD',
    });
  }
}

export const llmAgent = new LLMAgent();
